import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  ts = inject(TranslationService);
  t = this.ts.t;
  year = new Date().getFullYear();

  links = computed(() => ({
    solucoes:  [this.t().sol_card1_title, this.t().sol_card2_title, this.t().sol_card3_title, this.t().sol_card4_title],
    industrias:[this.t().ind_mining, this.t().ind_oil, this.t().ind_steel, this.t().ind_energy, this.t().ind_ports],
    empresa:   [this.t().footer_emp1, this.t().footer_emp2, this.t().footer_emp3, this.t().footer_emp4, this.t().footer_emp5],
  }));
}
